import { Button, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { ManageFooter, StyledDrawer, SignalTitle } from './styled';
import { FlexFill } from '../../../common/Utils/Layout';
import apptracker from '@src/utils/sensor/apptracker';
import { updateEventsOrderAtom } from '../../atoms';
import { useAtom } from 'jotai';
import DrawerCard from './DrawerCard';
import useEventsOverview from '../../hooks/useEventsOverview';

const { Text } = Typography;

const OVERVIEW_EVENTS_MAX_COUNT = 10;

const trackEvents = (events: string[]) => {
  apptracker('Add Events', {
    events,
  });
};

function EventsControl() {
  const { events } = useEventsOverview();
  const [tempSelected, setTempSelected] = useState<string[]>([]);
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    // Initialize temp selection with currently persisted events
    setTempSelected(events || []);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setTempSelected([]); // reset temp state
  };

  const onClear = () => {
    setTempSelected([]);
  };

  // Get the update atom
  const [, updateOrder] = useAtom(updateEventsOrderAtom);

  const applyEvents = () => {
    // Update event order - persistence is handled automatically at the dashboard level
    updateOrder(tempSelected);
    trackEvents(tempSelected);

    // Close the drawer
    onClose();
  };

  const renderDrawerTitle = () => {
    const count = tempSelected?.length || 0;
    return (
      <SignalTitle>
        <div>
          Events{' '}
          <Text
            type={count > OVERVIEW_EVENTS_MAX_COUNT ? 'warning' : undefined}
            className="signal-drawer-title"
          >
            {' '}
            {count}/{OVERVIEW_EVENTS_MAX_COUNT} Added{' '}
          </Text>
        </div>
      </SignalTitle>
    );
  };

  const footer = (
    <ManageFooter>
      <Button onClick={onClear} disabled={!tempSelected || tempSelected.length === 0}>
        Clear All
      </Button>
      <FlexFill />
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={applyEvents}
        type="primary"
        disabled={
          !tempSelected ||
          tempSelected.length === 0 ||
          tempSelected.length > OVERVIEW_EVENTS_MAX_COUNT
        }
      >
        Apply
      </Button>
    </ManageFooter>
  );

  return (
    <>
      <Space>
        <Button onClick={handleClick} icon={<PlusOutlined />}>
          Event
        </Button>
      </Space>
      <StyledDrawer
        title={renderDrawerTitle()}
        placement="right"
        onClose={onClose}
        open={open}
        footer={footer}
        destroyOnHidden={true}
      >
        <DrawerCard
          isDrawerOpen={open}
          selectedEventNames={tempSelected}
          onSelectionChange={setTempSelected}
        />
      </StyledDrawer>
    </>
  );
}

export default EventsControl;
